import { History } from "history";

import {
  ADD_TEACHER_ADMIN_USER,
  ADD_TEACHER_ADMIN_USER_ERROR,
  ADD_TEACHER_ADMIN_USER_SUCCESS,
  AddTeacherAdminUserAction,
  AddTeacherAdminUserErrorAction,
  AddTeacherAdminUserSuccessAction,
  DELETE_TEACHER_ADMIN_USER,
  DELETE_TEACHER_ADMIN_USER_CONSENT,
  DELETE_TEACHER_ADMIN_USER_ERROR,
  DELETE_TEACHER_ADMIN_USER_SUCCESS,
  DeleteTeacherAdminUserAction,
  DeleteTeacherAdminUserConsentAction,
  DeleteTeacherAdminUserErrorAction,
  DeleteTeacherAdminUserSuccessAction,
  GET_TEACHER_ADMIN_USER,
  GET_TEACHER_ADMIN_USERS,
  GET_TEACHER_ADMIN_USERS_ERROR,
  GET_TEACHER_ADMIN_USERS_SUCCESS,
  GET_TEACHER_ADMIN_USER_ERROR,
  GET_TEACHER_ADMIN_USER_SUCCESS,
  GetTeacherAdminUserAction,
  GetTeacherAdminUserErrorAction,
  GetTeacherAdminUserSuccessAction,
  GetTeacherAdminUsersAction,
  GetTeacherAdminUsersErrorAction,
  GetTeacherAdminUsersSuccessAction,
  UPDATE_TEACHER_ADMIN_USER,
  UPDATE_TEACHER_ADMIN_USER_ERROR,
  UPDATE_TEACHER_ADMIN_USER_SUCCESS,
  UpdateTeacherAdminUserAction,
  UpdateTeacherAdminUserErrorAction,
  UpdateTeacherAdminUserSuccessAction,
} from "./actionTypes";
import {
  CreateTeacherAdminRequest,
  PaginateQuery,
  TeacherAdminDto,
} from "../../../interfaces";
import { Paginated } from "../../../models";
import {} from "../../city/actionTypes";
import { RoleEnum } from "../../../enums";

//#region Get Teacher Admin Users

export const getTeacherAdminUsers = (
  role: RoleEnum,
  request: PaginateQuery,
  history: History
): GetTeacherAdminUsersAction => {
  return {
    type: GET_TEACHER_ADMIN_USERS,
    payload: { role, request, history },
  };
};

export const getTeacherAdminUsersSuccess = (
  response: Paginated<TeacherAdminDto>
): GetTeacherAdminUsersSuccessAction => {
  return {
    type: GET_TEACHER_ADMIN_USERS_SUCCESS,
    payload: response,
  };
};

export const getTeacherAdminUsersError = (
  error: any
): GetTeacherAdminUsersErrorAction => {
  return {
    type: GET_TEACHER_ADMIN_USERS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Teacher Admin User

export const getTeacherAdminUser = (
  id: string,
  history: History
): GetTeacherAdminUserAction => {
  return {
    type: GET_TEACHER_ADMIN_USER,
    payload: { id, history },
  };
};

export const getTeacherAdminUserSuccess = (
  response: TeacherAdminDto
): GetTeacherAdminUserSuccessAction => {
  return {
    type: GET_TEACHER_ADMIN_USER_SUCCESS,
    payload: response,
  };
};

export const getTeacherAdminUserError = (
  error: any
): GetTeacherAdminUserErrorAction => {
  return {
    type: GET_TEACHER_ADMIN_USER_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add Teacher Admin User

export const addTeacherAdminUser = (
  request: CreateTeacherAdminRequest,
  history: History
): AddTeacherAdminUserAction => {
  return {
    type: ADD_TEACHER_ADMIN_USER,
    payload: { request, history },
  };
};

export const addTeacherAdminUserSuccess =
  (): AddTeacherAdminUserSuccessAction => {
    return {
      type: ADD_TEACHER_ADMIN_USER_SUCCESS,
      payload: null,
    };
  };

export const addTeacherAdminUserError = (
  error: any
): AddTeacherAdminUserErrorAction => {
  return {
    type: ADD_TEACHER_ADMIN_USER_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update Teacher Admin User

export const updateTeacherAdminUser = (
  id: string,
  request: CreateTeacherAdminRequest,
  history: History
): UpdateTeacherAdminUserAction => {
  return {
    type: UPDATE_TEACHER_ADMIN_USER,
    payload: { id, request, history },
  };
};

export const updateTeacherAdminUserSuccess =
  (): UpdateTeacherAdminUserSuccessAction => {
    return {
      type: UPDATE_TEACHER_ADMIN_USER_SUCCESS,
      payload: null,
    };
  };

export const updateTeacherAdminUserError = (
  error: any
): UpdateTeacherAdminUserErrorAction => {
  return {
    type: UPDATE_TEACHER_ADMIN_USER_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete Teacher Admin User

export const deleteTeacherAdminUserConsent = (
  id: string
): DeleteTeacherAdminUserConsentAction => {
  return {
    type: DELETE_TEACHER_ADMIN_USER_CONSENT,
    payload: id,
  };
};

export const deleteTeacherAdminUser = (
  id: string,
  history: History
): DeleteTeacherAdminUserAction => {
  return {
    type: DELETE_TEACHER_ADMIN_USER,
    payload: { id, history },
  };
};

export const deleteTeacherAdminUserSuccess =
  (): DeleteTeacherAdminUserSuccessAction => {
    return {
      type: DELETE_TEACHER_ADMIN_USER_SUCCESS,
      payload: null,
    };
  };

export const deleteTeacherAdminUserError = (
  error: any
): DeleteTeacherAdminUserErrorAction => {
  return {
    type: DELETE_TEACHER_ADMIN_USER_ERROR,
    payload: error,
  };
};

//#endregion
